import { Common } from './common';
import { Event, EventV2, Query } from './models/timeline';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllEvents(query: Query): Promise<Event[]> {
    const url = this.common.constructPath(`/timeline`, query);
    return this.common.getJSON(url);
  }

  async findAllEventsV2(query: Query): Promise<EventV2[]> {
    const url = this.common.constructPath(`/timeline`, { v2: true, ...query });
    return this.common.getJSON(url);
  }
}
